import React, { useState } from "react";
import Slider from "react-slick";
import '../../node_modules/slick-carousel/slick/slick.css';
import '../../node_modules/slick-carousel/slick/slick-theme.css';
import * as styles from '../styles/carrousel.module.css';
import { graphql, useStaticQuery } from "gatsby";
import ReactImageVideoLightbox from '../../node_modules/react-image-video-lightbox/lib/index';

function Carrousel({ setVideoIndex }) {
  const data = useStaticQuery(graphql`
  query CarrousellData {
    allWorksDataJson {
      nodes {
        description
        title
        url
      }
    }
  }
  `)

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxOpenUrl, setLightboxOpenUrl] = useState('');
  const [lightboxOpenTitle, setLightboxOpenTitle] = useState('');

  const settings = {
    infinite: true,
    focusOnSelect: true,
    arrows: false,
    centerMode: true,
    speed: 500,
    variableWidth: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange(index) {
      setVideoIndex(index);
    },
    beforeChange: (current, index) => {
      setVideoIndex(index);
    },
  };


  function openLightbox(data) {
    setLightboxOpenUrl(data.url)
    setLightboxOpenTitle(data.title)
    setLightboxOpen(true);
  }


  return (
    <div className={styles.carrouselContainer}>
      <Slider {...settings}>
        {data.allWorksDataJson.nodes.map(data =>
        (
          <div key={data.title} className={styles.itemContainer}>
            <span className={styles.brand} >{data.title}</span>
            <div className={styles.proyectContainer}>
              <div className={styles.stroke}></div>
              <span aria-hidden="true" className={styles.workName} onClick={() => openLightbox(data)}>{data.description}</span>
            </div >
          </div>
        ))}
      </Slider>
      <div className={styles.lightbox}>
        {lightboxOpen && < ReactImageVideoLightbox
          data={
            [
              {
                url: `${lightboxOpenUrl}`,
                type: "video",
                altTag: `${lightboxOpenTitle}`,
                title: `${lightboxOpenTitle}`,
              }
            ]}
          startIndex={0}
          onCloseCallback={() => setLightboxOpen(false)}
        />
        }
      </div>
    </div>
  );
}

export default Carrousel;